import { useCallback, useRef } from 'react';

const DRAG_THRESHOLD = 5;

export default function useDragScroll() {
  const ref = useRef(null);
  const drag = useRef({ active: false, moved: false, startX: 0, startScroll: 0 });

  const onMouseDown = useCallback((event) => {
    const node = ref.current;
    if (!node || event.button !== 0) return;
    drag.current = { active: true, moved: false, startX: event.clientX, startScroll: node.scrollLeft };

    const onMove = (moveEvent) => {
      const state = drag.current;
      if (!state.active) return;
      const delta = moveEvent.clientX - state.startX;
      if (!state.moved && Math.abs(delta) < DRAG_THRESHOLD) return;
      if (!state.moved) {
        state.moved = true;
        node.classList.add('is-dragging');
      }
      moveEvent.preventDefault();
      node.scrollLeft = state.startScroll - delta;
    };

    const onUp = () => {
      drag.current.active = false;
      node.classList.remove('is-dragging');
      window.removeEventListener('mousemove', onMove);
      window.removeEventListener('mouseup', onUp);
    };

    window.addEventListener('mousemove', onMove);
    window.addEventListener('mouseup', onUp);
  }, []);

  const onClickCapture = useCallback((event) => {
    if (!drag.current.moved) return;
    event.preventDefault();
    event.stopPropagation();
    drag.current.moved = false;
  }, []);

  const onDragStart = useCallback((event) => event.preventDefault(), []);

  return { ref, onMouseDown, onClickCapture, onDragStart };
}
